<template>
    <div>  
      <!-- Modal -->
      <div class="transfer_modal modal fade" ref="cashPaymentModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-size" role="document">
          <div class="modal-content fixed-modal">
            <div class="modal-body">
              <div class="transfer_modal_header d-flex justify-content-between">
                <h5 class="modal-title" id="exampleModalLabel">Payment Information</h5>
                <button type="button" class="close btn" @click="hideModal" aria-label="Close">
                  X
                </button>
              </div>
              <div v-if="cashPaymentStore.payment.drivers && cashPaymentStore.payment.drivers[0]" class="row d-flex align-items-stretch">
                <div class="col-md-3 col-12">
                  <!-- 司機資訊 -->
                  <div class="card h-100">
                    <div class="card-body">
                      <h5>Licensing & Operations</h5>
                      <div class="form-group">
                        <label for="driver-id">Driver ID</label>
                        <input type="text" id="driver-id" class="form-control" :value="cashPaymentStore.payment.drivers[0].driver_id" disabled />
                      </div>
                      <div class="form-group">
                        <label for="driver-name">Name</label>
                        <input type="text" id="driver-name" class="form-control" :value="driverFullName" disabled />
                      </div>
                      <div class="form-group">
                        <label for="plate">Plate</label>
                        <input type="text" id="plate" class="form-control" :value="cashPaymentStore.payment.drivers[0].license.plate_number" disabled />
                      </div>
                      <div class="form-group" v-if="licenseFrontUrl">
                        <label for="driver-license">Associated driving license</label>
                        <div class="border border-1">
                          <img :src="licenseFrontUrl" alt="Driver License" class="img-fluid mb-2 mt-2 driver-license-image" @click="showLicenseModal" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-9 col-12">
                  <!-- 計算所選Transaction Info -->
                  <div class="transfer_card_container card">
                    <div class="card-body">
                      <h5>Payment info</h5>
                      <div class="table-responsive">
                        <table class="table table-bordered table-hover">
                          <thead class="thead-light">
                            <tr>
                              <th>Transactions</th>
                              <th>$SFV</th>
                              <th>Commission amount</th>
                              <th>Fees & Refunds</th> 
                              <th>Total</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{{ selectedSummary.transactionCount }}</td>
                              <td>{{ formatCurrency(selectedSummary.totalSFV) }}</td>
                              <td>{{ formatCurrency(selectedSummary.totalCommissionAmount) }}</td>
                              <td>{{ formatCurrency(selectedSummary.totalFeesAndRefunds) }}</td> 
                              <td>{{ formatCurrency(selectedSummary.totalAmount) }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <!-- 交易資訊 -->
                  <div class="card mb-0 payment-info-h h-auto">
                    <div class="card-body">
                      <div class="table-responsive mt-3">
                        <table class="table table-hover">
                          <thead class="thead-light">
                            <tr>
                              <th>Tx Date/Time</th>
                              <th>Type</th>
                              <th>Driver name</th>
                              <th>Driver ID</th>
                              <th>Face value</th>
                              <th>Comm'n %</th>
                              <th>Comm'n amount</th>
                              <th>Bank Ref</th>
                              <th>Terminal</th>
                              <th>Card type</th>
                              <th>Card last 4 digits</th>
                            </tr>
                          </thead>
                          <tbody v-if="cashPaymentStore.editTransaction.length === 0">
                            <tr>
                              <td colspan="11">
                                <div class="no-results">No results found.</div>
                              </td>
                            </tr>
                          </tbody>
                          <tbody v-else>
                            <tr v-for="(item, index) in paginatedTransactions" :key="index">
                              <td>{{ item.transaction_datetime }}</td>
                              <td>{{ item.type }}</td>
                              <td>{{ item.driver_name }}</td>
                              <td>{{ cashPaymentStore.payment.drivers[0].driver_id}}</td>
                              <td>{{ formatCurrency(item.face_value) }}</td>
                              <td>{{ item.commn_percent }}</td>
                              <td>{{ formatCurrency(item.comm_amount) }}</td>
                              <td>{{ item.rrn }}</td>
                              <td>{{ item.tid }}</td>
                              <td>{{ item.card_type }}</td>
                              <td>{{ item.card_last_4_digits }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <!-- 分頁 -->
                      <div class="pagination-wrapper">
                        <div class="pagination-container">
                          <button @click="changeEditPageTransactionPage(1)" :disabled="cashPaymentStore.editPageCurrentPageTransactions === 1"><img  src="@/assets/images/admin/arrow/prev-end.png" alt="Prev-end" style="width: 25px; height: 25px;" /></button>
                          <button @click="changeEditPageTransactionPage(cashPaymentStore.editPageCurrentPageTransactions - 1)" :disabled="cashPaymentStore.editPageCurrentPageTransactions === 1"><img  src="@/assets/images/admin/arrow/prev-end.png" alt="Prev-end" style="width: 25px; height: 25px;" /></button>
                          <span>Page <input type="number" v-model.number="cashPaymentStore.editPageCurrentPageTransactions" @change="changeEditPageTransactionPage(cashPaymentStore.editPageCurrentPageTransactions)" /> of {{ totalEditTransactionPages }}</span>
                          <button @click="changeEditPageTransactionPage(cashPaymentStore.editPageCurrentPageTransactions + 1)" :disabled="cashPaymentStore.editPageCurrentPageTransactions === totalEditTransactionPages"><img  src="@/assets/images/admin/arrow/next.png" alt="Next" style="width: 25px; height: 25px;" /></button>
                          <button @click="changeEditPageTransactionPage(totalEditTransactionPages)" :disabled="cashPaymentStore.editPageCurrentPageTransactions === totalEditTransactionPages"><img  src="@/assets/images/admin/arrow/next-end.png" alt="Next-end" style="width: 25px; height: 25px;" /></button>
                        </div>
                        <div class="total-count">
                          Displaying transactions {{ (cashPaymentStore.editPageCurrentPageTransactions - 1) * cashPaymentStore.editPageItemsPerPageTransactions + 1 }} – {{ Math.min(cashPaymentStore.editPageCurrentPageTransactions * cashPaymentStore.editPageItemsPerPageTransactions, cashPaymentStore.totalEntries) }} of {{ cashPaymentStore.totalEntries }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="transfer_footer modal-footer">
                <button class="btn btn-green" @click="handEmail">Email</button>
                <button class="btn btn-green" @click="handPrint">Print</button>
                <button class="btn btn-w" @click="hideModal">Close</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 駕照放大Modal -->
      <div class="modal fade" ref="licenseModal" tabindex="-1" role="dialog" aria-labelledby="licenseModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="licenseModalLabel">Driving License</h5>
              <button type="button" class="close" @click="hideLicenseModal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body text-center">
              <img :src="currentLicenseImage" alt="Driver License" class="img-fluid" />
            </div>
          </div>
        </div>
      </div>
      <div v-if="emailLoading" class="spinner-overlay">
        <div class="spinner"></div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref, computed, onMounted, defineExpose } from 'vue';
  import { Modal } from 'bootstrap';
  import { useCashPaymentStore } from '@/store/admin/cashPayment/cashpayment';
  
  const cashPaymentStore = useCashPaymentStore();
  const cashPaymentModal = ref(null);
  const licenseModal = ref(null);
  let modalInstance = null;
  let licenseModalInstance = null;
  const selectId = ref('');

  const currentLicenseImage = ref('');

  // 取得駕照 URL
  const licenseFrontUrl = computed(() => cashPaymentStore.document_url);

  // 顯示駕照放大Modal
  const showLicenseModal = () => {
    if (!licenseModalInstance) {
      licenseModalInstance = new Modal(licenseModal.value);
    }
    currentLicenseImage.value = licenseFrontUrl.value;
    licenseModalInstance.show();
  };

  // 隱藏駕照放大Modal
  const hideLicenseModal = () => {
    if (licenseModalInstance) {
      licenseModalInstance.hide();
    }
  };
  
  const defaultLicenseImage = require('@/assets/images/admin/cashpayments/image.png');
  
  // 顯示Modal
  const showModal = async (id) => {
    if (!modalInstance) {
      modalInstance = new Modal(cashPaymentModal.value);
    }
    selectId.value = id;
    await cashPaymentStore.fetchPaymentById(selectId.value); // 獲取付款信息
    modalInstance.show();
  };
  
  // 隱藏Modal
  const hideModal = () => {
    if (modalInstance) {
      modalInstance.hide();
    }
  };
  
  // 計算司機全名
  const driverFullName = computed(() => {
    const driver = cashPaymentStore.payment.drivers?.[0];
    return driver ? `${driver.first_name} ${driver.middle_name} ${driver.last_name}` : '';
  });
  
  // 切換交易頁面
  const changeEditPageTransactionPage = (page) => {
    cashPaymentStore.changeEditPageTransactionPage(page);
  };
  
  //分頁計算
  const paginatedTransactions = computed(() => {
    return cashPaymentStore.editPagePaginatedTransactions;
  });
  
  const totalEditTransactionPages = computed(() => {
    return cashPaymentStore.totalEditTransactionPages;
  });
  
  //計算後端回傳Transaction數據
  const selectedSummary = computed(() => {
    const transactionCount = cashPaymentStore.editTransaction.length;
    const totalSFV = cashPaymentStore.payment.face_value;
    const totalCommissionAmount = cashPaymentStore.payment.comm_amount;
    const totalFeesAndRefunds = cashPaymentStore.edit_fees_and_refunds;
    const totalAmount = cashPaymentStore.payment.paid;
  
    return {
      transactionCount,
      totalSFV,
      totalCommissionAmount,
      totalFeesAndRefunds,
      totalAmount
    };
  });

  const formatCurrency = (value) => {
    const absValue = Math.abs(value).toFixed(2); // 取得絕對值並固定為兩位小數
    return value < 0 ? `-$${absValue}` : `$${absValue}`;
};

  const emailLoading = ref(false);

  //寄送Email
  const handEmail = async () => {
    emailLoading.value = true;
    try {
      await cashPaymentStore.mailPayments(selectId.value); // 呼叫 API 寄送 Email
    } catch (error) {
      console.error(error);
    } finally {
      emailLoading.value = false;
    }
  };

  //印出該筆
  const handPrint = async() =>{
    await cashPaymentStore.printPayments(selectId.value); // 獲取付款信息
  };
  
  onMounted(() => {
    cashPaymentStore.editPageCurrentPageTransactions = 1; // 初始化交易分頁頁碼
  });

  defineExpose({
    showModal
  })
  </script>
  
  
  <style scoped>
  .btn-green:hover {
    background: #00b452;
  }
  
  .modal-size {
    max-width: 80%;
  }
  
  .table-responsive {
    max-height: 300px;
    overflow-y: auto;
    padding-top: 0px;
  }
  
  .driver-license-image {
    max-width: 100%;
    max-height: 200px;
    object-fit: cover;
  }
  
  .no-results {
    border-radius: 20px;
    padding: 50px;
    font-size: 20px;
    text-align: center;
    color: black;
    background-color: #ccd3da;
  }
  
  .fixed-modal {
    overflow: hidden;
  }
  
  .form-group {
    margin-top: 10px;
  }
  
  .thead-light th {
    background-color: #f8f9fa;
    color: #495057;
  }
  
  .modal-header {
    background-color: #f8f9fa;
    border-bottom: 1px solid #dee2e6;
    justify-content: space-between;
  }
  
  .driver-license-image {
    cursor: pointer;
    max-width: 100%;
    max-height: 200px;
    object-fit: cover;
  }

  .modal-dialog-centered {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  
  .table-responsive .table tbody tr td:nth-child(n+2) {
    min-width: 150px !important;
  }
  
  .card {
    background-color: #e6e9ec;
  }

  .license-card{
  border-radius: 5px;
  padding: 5px;
  padding-top: 10px;
  background-color: white;
}
  
  .card-body {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .payment-info-h{
    min-height: 360px;
  }

  /* Loading overlay 與 spinner 樣式 */
  .spinner-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2000;
  }

  .spinner {
    width: 60px;
    height: 60px;
    border: 6px solid #f3f3f3;
    border-top: 6px solid #00c962;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
  
  @media (max-width: 768px) {
    .modal-size {
      max-width: 100%;
    }
  
    .table-responsive {
      max-height: 250px;
    }
  
    .table {
      font-size: 12px;
    }
  }
  
  .pagination-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0;
  }
  
  .pagination-container {
    display: flex;
    align-items: center;
  }
  
  .pagination-container button {
    border: none;
    background: none;
    cursor: pointer;
    font-size: 16px;
    color: #8476f4;
  }
  
  .pagination-container span {
    margin: 0 10px;
  }
  
  .pagination-container input {
    width: 50px;
    text-align: center;
  }
  
  .total-count {
    font-size: 16px;
    color: #666;
  }
  
  @media (max-width: 630px) {
    .pagination-wrapper {
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  
    .pagination-summary {
      margin-top: 10px;
      justify-content: center;
    }
  
    .pagination-container {
      justify-content: center;
      width: 100%;
      margin-bottom: 10px;
    }
  }
  
  @media (max-width: 768px) {
    .card-body {
      padding: 10px;
    }
  
    .filter-toggle-icon {
      justify-content: center;
      font-size: 20px;
    }
  
    .btn-reset, .btn-green, .btn-toggle {
      width: 100%;
      margin-top: 10px;
    }
  
    .btn-reset {
      margin-right: 0;
    }
  
    .text-end {
      text-align: center !important;
    }
  }
  </style>
  